import React, { ReactNode } from 'react'
import { SidebarLayout, useForTablet } from '@sketch/components'
import { usePrototypeStatus } from '@sketch-hq/sketch-web-renderer'
import { useVersioning } from 'modules/versioning'
import ShareWorkspaceSidebar from 'modules/shares/components/ShareWorkspaceSidebar'
import { PrototypeEmptyHeader, PrototypeHeader } from '../PrototypeHeader'
import { PrototypeFooter } from '../PrototypeFooter/PrototypeFooter'

type PrototypeLayoutProps = {
  children: ReactNode
}

/**
 * Top-level global layout for everything shown within the Prototype view.
 */
export function PrototypeLayout(props: PrototypeLayoutProps) {
  const status = usePrototypeStatus()
  const isPrototypeReady = status.type === 'READY'
  const versioning = useVersioning()
  const isTabletAndBigger = useForTablet()

  // If the prototype is not ready, or the versioning is loading, use a
  // a bare-bones layout
  if (!isPrototypeReady || versioning.loading) {
    return (
      <SidebarLayout
        darkBackground
        sidebarLeft={null}
        header={<PrototypeEmptyHeader />}
        footer={null}
      >
        {props.children}
      </SidebarLayout>
    )
  }

  return (
    <SidebarLayout
      darkBackground
      sidebarLeft={
        <ShareWorkspaceSidebar
          workspaceIdentifier={versioning.share.workspace.identifier}
        />
      }
      header={headerProps => (
        <PrototypeHeader
          setSidebarLeftOpen={headerProps.setSidebarLeftOpen}
          share={versioning.share}
        />
      )}
      footer={!isTabletAndBigger && <PrototypeFooter />}
    >
      {props.children}
    </SidebarLayout>
  )
}
